/*=============================================== DropdownPage ===============================================*/

import { useState } from "react"
import { Link } from "react-router-dom"
import { Dropdown, DropdownContainer, Button, Text } from "tsx-library-julseb"
import type { DropdownItemProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, listDirection, propAllLinksClickRequired } from "data"

const DropdownPage = () => {
    const dropdownItems: DropdownItemProps[] = [
        {
            text: "Link",
            to: "/",
        },
        {
            text: "Button",
            onClick: () => alert("Clicked"),
        },
    ]

    const [isOpen, setIsOpen] = useState<boolean>(false)

    const items: ItemType[] = [
        {
            content: (
                <DropdownContainer>
                    <Button onClick={() => setIsOpen(!isOpen)}>
                        Open dropdown
                    </Button>

                    <Dropdown
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        items={dropdownItems}
                    />
                </DropdownContainer>
            ),
            code: 'const dropdownItems = [\n    {\n        text: "Link",\n        to: "/",\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n]\n\nconst [isOpen, setIsOpen] = useState(false)\n\n<DropdownContainer>\n    <Button onClick={() => setIsOpen(!isOpen)}>Open dropdown</Button>\n    <Dropdown isOpen={isOpen} setIsOpen={setIsOpen} items={dropdownItems} />\n</DropdownContainer>',
            codeTs: 'const dropdownItems: DropdownItemProps[] = [\n    {\n        text: "Link",\n        to: "/",\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n]\n\nconst [isOpen, setIsOpen] = useState<boolean>(false)\n\n<DropdownContainer>\n    <Button onClick={() => setIsOpen(!isOpen)}>Open dropdown</Button>\n    <Dropdown isOpen={isOpen} setIsOpen={setIsOpen} items={dropdownItems} />\n</DropdownContainer>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            title: "DropdownContainer",
            componentIntro: (
                <Text>
                    For the <code>DropdownContainer</code>, we are only using
                    the <Link to="/layouts/flexbox">Flexbox</Link> component
                    props.
                </Text>
            ),
            isOnlyExtending: true,
        },
        "separator",
        {
            subtitle: "as",
            intro: "Changes the HTML tag",
            type: "string",
            possibleString: "Any HTML tag",
            default: "div",
        },
        {
            subtitle: "isOpen",
            type: "boolean",
            required: true,
        },
        {
            subtitle: "setIsOpen",
            type: "function",
            required: true,
        },
        listDirection("direction"),
        "separator-small",
        {
            subtitle: "items",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>item</code> object
                </>
            ),
            subtitle: "text",
            type: "string",
            required: true,
        },
        ...propAllLinksClickRequired,
        {
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default DropdownPage
